import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericService } from 'app/_services/generic.service';
import { environment } from "environments/environment";
import { AgandaTypeModel } from './models/aganda-type.model';
@Injectable({
    providedIn: 'root',
})

export class AgendaTypeService extends GenericService<AgandaTypeModel> {
  rootApiUrl: string = environment.Services.AlphaURLSlot2;

    constructor(private http: HttpClient) {
        super(http,'/AgendaType/', environment.Services.AlphaURLSlot1)
    }

    getAgendaTypeByCulture(culture,includeCache: boolean = false) {
      return this.http.get(
        this.rootUrl + "/AgendaType/getByCulture/" + culture,
        this.generateHeaders(includeCache)
      );
    }

    private generateHeaders(includeCache: boolean = false) {
      let headersConfig = {
          'Content-Type': 'application/json'
      };

      if (!includeCache) {
        headersConfig['Cache-Control'] = 'no-cache';

      }
      return {
          headers: new HttpHeaders(headersConfig),
      };
  }
}